import React from "react";
import "./portfolio.css";
import { portfolio_data } from "./data";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {portfolio_data.map((project) => (
          <article className="portfolio__item" key={project.title}>
            <div className="portfolio__item-image">
              <img src={project.image} alt="" />
            </div>
            <h3>{project.title}</h3>
            <div className="portfolio__item-cta">
              <a
                href={project.link}
                className="btn"
                target="_blank"
                rel="noreferrer"
              >
                Github
              </a>
              <a href={project.link_questions} className="btn btn-primary">
                Questions?
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
